export default __webpack_public_path__ + "static/media/icon.delete.122a8f24.svg";